import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Flex } from '@modusign/design-system';

interface CheckIconProps {
  active: boolean;
}

export default function CheckIcon({ active }: CheckIconProps) {
  return (
    <Flex
      alignItems="center"
      borderRadius={12}
      height={24}
      justifyContent="center"
      sx={
        active
          ? { color: 'iconNeutralVeryDark', backgroundColor: 'statusBackgroundPrimaryBase' }
          : {
              color: 'iconNeutralBase',
              borderColor: 'statusBorderNeutralSlightlyLight',
              borderStyle: 'solid',
              borderWidth: 1,
            }
      }
      width={24}
    >
      <FontAwesomeIcon icon={faCheck} />
    </Flex>
  );
}
